/* eslint-disable */
import React, { useEffect, useState, useMemo } from "react";
import { LinkCard } from "../../stories/cards/LinkCard";
import { Spinner, Alert } from "react-bootstrap";
import { Button } from "../../stories/Buttons/Button";
import ReactMarkdown from "react-markdown";
import WellnessTimeline from "../TestDetails/WellnessTimeline";
import useApis from "../../services/useAPI";
import ReportHighlightSection from "../WellnessReports/ReportHighlightsSection";
import ActivateKit from "../../assets/icons/Timeline/Desktop/Icons/4CollectSample.svg";
import Clipboard from "../../assets/icons/Clipboard.svg";
import KitDispatched from "../../assets/icons/Timeline/Desktop/Icons/3KitDispatched.svg";
import LabAnalysis from "../../assets/icons/Timeline/Desktop/Icons/6SampleReceived.svg";
import Doctor from "../../assets/icons/Doctor.svg";
import PhoneConsultation from "../../assets/icons/Phone_Consultation_icon.svg";
import Results from "../../assets/icons/Platform/Results.svg";
import { useMediaQuery } from "react-responsive";
import { trimAllWhiteSpaces } from "../../utils/utils";
import {
  blockedKitError,
  logoutUrl,
  myResultUrl,
  wellnessReportUrl,
  assessmentStatusUrl,
  royalMailTrackingUrl
} from "../../utils/constants";
import axios from "axios";
import { useAuth } from "../../components/AuthContext/AuthContext";
import AssessmentInstruction from "./AssessmentInstruction";
import Cookies from "js-cookie";
import { ErrorDisplay } from "../Errors/ErrorDisplay";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import ActionCard from "../../stories/cards/ActionCard/ActionCard";
import { XSquare } from "react-bootstrap-icons";
import ResultCard from "../../stories/cards/ResultCard";
import ArticleCarouselB12 from "../../stories/Carousel/ArticleCarouselB12";
import UserProfile from "../../components/UserProfile";
import article1 from "../../assets/images/image1.png";
import article2 from "../../assets/images/image2.png";
import article3 from "../../assets/images/image1.png";
import convert from "convert-units";
import Card from "react-bootstrap/Card";
import ArticleCard from "../../stories/cards/ArticleCard";
import TestKitCarousel from "../../stories/Carousel/TestKitCarousel";
import DashboardArticleCarousel from "../../stories/Carousel/DashboardArticleCarousel";
import TestKitTracker from "../../stories/cards/TestKitTrackerCard.jsx";
import ActionRequiredCard from "../../stories/cards/ActionRequired/ActionRequiredCard";
import nhsCardImage from "../../assets/images/nhs-card-image.png";
import NewTestCard from "../../stories/cards/NewTestCard.jsx";
import AppointmentDetails from "./AppointmentDetails.jsx";

export const statuses = [
  "error", // Other error - contact customer care
  "rejected", // Other error - contact customer care
  "created", // Not yet linked to a user
  "quarantined",
  "quarantine-cleared",
  "activated", // The user has activated with the basic info needed for the rec-engine (Also display as awaiting sample return)
  "processing", // The lab has received the samples (Sample Taken and Returned, or Sample received at Lab, in the lab, or results pending)
  "report-in-review", // In review by the doctor (Name may change depending on Matt's implantation) With Doctor
  "report-ready", // Reviewed by the doctor and ready to view
];

// Order of reasons is important
export const errorReasons = Object.freeze([
  "missing-assessment",
  "marked-rejected",
  "sample-not-received",
  "lab-delay",
  "unexpected-results",
  "missing-assessment-hormones",
  "untestable",
  "inhibitory",
  "gp-delay",
]);

export const steps = [
  {
    label: "Test Activated",
    isVisible: (unconfirmed_result) => {
      return true;
    },
    inProgress: (status) =>
      status === "created" ||
      status === "quarantined" ||
      status === "activating",
    isCompleted: (status, errorReason, is_activated) => {
      const activeIndex = statuses.findIndex((s) => s === status);
      const stepIndex = statuses.findIndex(
        (s) => s === "activated" || s === "quarantine-cleared",
      );
      return activeIndex >= stepIndex || !!errorReason;
    },
    failed: (status, errorReasons, is_activated) => {
      return status === "error" && !is_activated ? true : false;
    },
    graphic: ActivateKit,
  },
  {
    label: "Assessment Completed",
    label_before: "Complete Assessment",
    name: "assessment",
    isVisible: () => true,
    inProgress: (status) => status === "processing",
    isCompleted: (status, errorReason) => {
      const activeIndex = statuses.findIndex((s) => s === status);
      const stepIndex = statuses.findIndex((s) => s === "processing");
      const activeErrorIndex = errorReasons.findIndex((s) => s === errorReason);
      const errorIndex = errorReasons.findIndex(
        (s) =>
          s === "missing-assessment" || s === "missing-assessment-hormones",
      );

      return activeIndex > stepIndex || activeErrorIndex > errorIndex; //&& status !== 'error'
    },
    failed: (_status, errorReason) =>
      errorReason === "missing-assessment" ||
      errorReason === "missing-assessment-hormones",
    graphic: Clipboard,
    link: "/assessment/{test_id}/1",
  },
  {
    label: "Sample Taken & Returned",
    isVisible: (unconfirmed_result) => {
      return true;
    },
    inProgress: (status) =>
      status === "activated" || status === "quarantine-cleared",
    isCompleted: (status, errorReason) => {
      const activeIndex = statuses.findIndex((s) => s === status);
      const stepIndex = statuses.findIndex(
        (s) => s === "activated" || s === "quarantine-cleared",
      );
      const activeErrorIndex = errorReasons.findIndex((s) => s === errorReason);
      const errorIndex = errorReasons.findIndex(
        (s) => s === "sample-not-received",
      );

      return (
        activeIndex > stepIndex ||
        activeErrorIndex > errorIndex ||
        errorReason === "marked-rejected"
      );
    },
    failed: (_status, errorReason) =>
      errorReason === "sample-not-received" ||
      errorReason === "marked-rejected" ||
      _status === "error",
    instructions: ({ filledAssessment, test_id, viewInstructionsUrl, bid }) => {
      <>
        <AssessmentInstruction
          bid={bid}
          viewInstructionsUrl={viewInstructionsUrl}
          filledAssessment={filledAssessment}
          test_id={test_id}
        />
      </>;
    },
    graphic: KitDispatched,
  },
  {
    label: "Analysed at Lab",
    isVisible: (unconfirmed_result) => {
      return true;
    },
    inProgress: (status) => status === "processing",
    isCompleted: (
      status,
      errorReason,
      is_activated,
      consultation_status,
      partial_result,
    ) => {
      const activeIndex = statuses.findIndex((s) => s === status);
      const stepIndex = statuses.findIndex((s) => s === "processing");
      const activeErrorIndex = errorReasons.findIndex((s) => s === errorReason);
      const errorIndex = errorReasons.findIndex((s) => s === "lab-delay");
      //  test_kit_status,
      //       errorReason || errorReasonValue,
      //       is_activated,
      //       consultation_status
      return (
        (activeIndex > stepIndex || activeErrorIndex > errorIndex) &&
        !partial_result
      );
    },
    failed: (
      _status,
      errorReason,
      is_activated,
      consultation_status,
      calendly_status,
      attempt_type,
      outcome,
      archive_reason,
      partial_result,
    ) => {
      if (partial_result) return true;
      if (!errorReason) return false;
      const reasons = [
        "lab-delay",
        "unexpected-results",
        "untestable",
        "inhibitory",
        // "marked-rejected"
      ];
      return reasons.includes(errorReason);
    },
    // test_kit_status,
    //   errorReason || errorReasonValue,
    // is_activated,
    // consultation_status,
    // calendly_status,
    // attempt_type,
    // outcome,
    // archive_reason,
    // partial_result
    instructions: () => (
      <>
        Your kit has been received by our laboratory. Analysis of your sample is
        in progress.
      </>
    ),
    graphic: LabAnalysis,
  },
  {
    label_before: "In review with a Doctor",
    label: "Reviewed by Doctor",
    isVisible: (unconfirmed_result) => {
      return true;
    },
    inProgress: (status, is_activated, errorReason, consultation_status) => {
      if (
        consultation_status === "consultation" ||
        consultation_status === "consulted"
      ) {
        return false;
      } else {
        return status === "report-in-review" || errorReason === "gp-delay";
      }
    },
    isCompleted: (status, errorReason, is_activated, consultation_status) => {
      if (
        consultation_status === "consultation" ||
        consultation_status === "consulted"
      ) {
        return true;
      } else {
        const activeIndex = statuses.findIndex((s) => s === status);
        const stepIndex = statuses.findIndex((s) => s === "report-in-review");
        return activeIndex > stepIndex && status !== "error";
      }
    },
    failed: (_status, errorReason) => errorReason === "gp-delay",
    graphic: Doctor,
    instructions: (consultation_status) =>
      !consultation_status ? (
        <>
          Your sample has been analysed by our laboratory. Your results are in
          review with our doctor.
        </>
      ) : (
        <></>
      ),
  },
  {
    label: "Consultation Completed",
    label_before: "Consultation Required",
    isVisible: (unconfirmed_result) => {
      return unconfirmed_result;
    },
    inProgress: (status, errorReason, is_activated, consultation_status) => {
      return consultation_status === "consultation" ? true : false;
    },
    isCompleted: (status, errorReason, is_activated, consultation_status) => {
      return consultation_status === "consulted" ? true : false;
    },
    failed: (
      _status,
      errorReason,
      is_activated,
      consultation_status,
      calendly_status,
      attempt_type,
      outcome,
    ) => {
      return calendly_status === "reschedule_2" &&
        (outcome === "not_answered" || outcome === "not_attended")
        ? true
        : false;
    },
    graphic: PhoneConsultation,
  },
  {
    label: "Results Ready",
    isVisible: (unconfirmed_result) => {
      return true;
    },
    label_before: "Get Results",
    inProgress: (status) => false,
    isCompleted: (status, errorReason) => status === "report-ready",
    failed: (
      _status,
      errorReason,
      is_activated,
      consultation_status,
      calendly_status,
      attempt_type,
      outcome,
    ) => {
      return calendly_status === "reschedule_2" &&
        (outcome === "not_answered" || outcome === "not_attended")
        ? true
        : false;
    },
    graphic: Results,
  },
];

const Dashboard = (props) => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const location = useLocation();
  const isPhlebotomy = localStorage.getItem("is_phlebotomist") === "true";

  // Convert the query string into an object
  const queryParams = new URLSearchParams(location.search);

  // Get the value of the "code" query parameter
  const code = queryParams.get("code");
  const error = queryParams.get("error");
  const [testReportValue, setTestReportValue] = useState(0);
  const { callApi, resultGet, resultPost, isLoading, serverError } =
    useApis() || {};
  const [testFlag, setTestFlag] = useState(1);
  const [pkbConsented, setPkbConsented] = useState();
  const [isTestKitDetails, setIsTestKitDetails] = useState(false);
  const appointmentData = null;
  const auth = useAuth();
  const [bodyDetails, setBodyDetails] = useState([]);
  const navigate = useNavigate();

  const [isVitaminB12Flag, setIsVitaminB12Flag] = useState(null);
  const [vitabinB12reportPublishedDate, setVitabinB12reportPublishedDate] =
    useState(null);
  const [vitaminMarkerValue, setvitaminMarkerValue] = useState(null);
  const [errors, setErrors] = useState("");
  const [reports, setReports] = useState(null);
  const [test, setTest] = useState(null);
  const [getResult, setGetResult] = useState(true);
  const [loading, setLoading] = useState(true);
  const [pkbLoading, setPkbLoading] = useState(false);
  const [showRegistering, setShowRegistering] = useState();
  const [redirectLink, setRedirectLink] = useState(null);
  const [height, setHeight] = useState(0);
  const [weight, setWeight] = useState(0);
  const [bmi, setBmi] = useState(0);
  const [testDetails, setTestDetails] = useState(null);
  const [firstName, setFirstName] = useState("");
  const [gender, setGender] = useState("");
  const [age, setAge] = useState("");
  const [reportPublishedDate, setReportPublishedDate] = useState("");
  const [dNAReportPublishedDate, setDNAReportPublishedDate] = useState("");
  const trackingUrl = trimAllWhiteSpaces(
    royalMailTrackingUrl(test?.postage_tracking),
  );

  const handleNo = () => {
    setShowRegistering(false);
    navigate("/pkb/registration", { state: getResult.data });
  };

  const handleReactivateConsent = () => {
    callApi(
      { user_id: JSON.parse(localStorage.getItem("user_id")) },
      "/api/dashboard/pkb-reactivate-consent/",
      "POST",
      true,
    );
  };

  const testKitTrackerTitle = () => {
    return (
      <div className="test-status">
        <h5 className="fs-20 mb-0 lh-1">
          <b className="text-color-for-mhc">Test status</b>
        </h5>
        {test?.bid !== null ? "" : (
        <span className="test-order-text">
          Tracking number:{" "}
          <a
            href={trackingUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="test-order-tracking-number"
          >
            {test?.postage_tracking}
          </a>
        </span>)}
      </div>
    );
  };

  useEffect(() => {
    localStorage.setItem("verifyCard", false);
    localStorage.setItem("isLoggedIn",true);
  });

  useEffect(() => {
    const fetchTests = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${myResultUrl}?latest=${Boolean(true)}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("access_token")}`,
            },
          },
        );

        setGetResult(response);
        if (response?.data) {
          setIsTestKitDetails(response?.data?.is_associate_testkit);
          setFirstName(
            response?.data?.first_name,
          );
          setGender(
            response?.data?.sex,
          );
          setAge(
            response?.data?.age,
          );
          setTestReportValue(
            response?.data?.test_kits?.data[0]?.reported_value,
          );
          setRedirectLink(response?.data?.pkb_redirection_url);
          setIsVitaminB12Flag(
            response?.data?.test_kits?.data[0]?.is_vitamin_flag,
          );
          setVitabinB12reportPublishedDate(
            response?.data?.test_kits?.data[0]?.vitamin_test_reported_date,
          );
          setvitaminMarkerValue(
            response?.data?.test_kits?.data[0]?.vitamin_marker_value,
          );
          setTestFlag(
            response?.data?.test_kits?.data[0]?.type.includes("dna-") ||
              response?.data?.test_kits?.data[0]?.type?.includes("boots-dna-")
              ? 0
              : 1,
          );
          setTest(response?.data?.test_kits?.data[0]);
        }

        if (response?.data?.user_pkb_status) {
          setPkbConsented(response?.data?.user_pkb_status);
          localStorage.setItem("pkb_status", response?.data?.user_pkb_status);
        } else {
          setPkbConsented(false);
        }
      } catch (error) {
        if (
          error?.response?.data?.session_expired ||
          error?.response?.data?.unauthorized ||
          error?.response?.data?.error === "Token is missing"
        ) {
          callApi(null, logoutUrl, "POST");
          auth.logout();
          auth?.showToast(
            "Error",
            "You have logged in to another device",
            "../assets/mhc.png",
            <XSquare />,
          );
        }
      } finally {
        setLoading(false);
      }
    };

    fetchTests();
  }, [auth?.editReload]);

  // Fetches wellness reports data from the API
  useEffect(() => {
    if (
      test?.report_id &&
      (test?.type?.includes("dna-") || test?.type?.includes("boots-dna-"))
    ) {
      callApi(null, wellnessReportUrl(test.report_id), "GET");
    }
  }, [test?.report_id]);

  useEffect(() => {
    localStorage.setItem("sex", gender);
    async function fetchAssessment() {
      if (getResult?.data?.test_kits?.data[0]?.id) {
        const response = await axios.get(
          `${assessmentStatusUrl}${getResult?.data?.test_kits?.data[0]?.id}`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("access_token")}`,
            },
          },
        );
        if (response?.data) {
          setTestDetails(response?.data);
          const body = response?.data?.assessment_values?.body;
          setBodyDetails(response?.data?.assessment_values?.body);
          setReportPublishedDate(response?.data?.test_kit_details?.review_ts);
          setDNAReportPublishedDate(
            response?.data?.test_kit_details?.dna_report_ts,
          );
        }
      }
    }
    fetchAssessment();
  }, [test?.report_id, test, getResult]);

  // Updates reports state when API result changes
  useEffect(() => {
    if (resultGet) {
      setReports([resultGet]);
    }
    if (resultPost && !serverError) {
      auth?.showToast("Success!", resultPost.message);
      navigate("/pkb/success");
    } else if (serverError) {
      auth?.showToast("Error", serverError);
      navigate("/");
    }
  }, [resultGet, resultPost, pkbConsented, serverError]);

  useEffect(() => {
    const sendPKBConsent = async () => {
      setPkbLoading(true);
      try {
        const response = await axios.post(`/api/dashboard/pkb-nhs-number/`, {
          code: code,
          user_id: localStorage.getItem("user_id"),
        });

        if (response.data.success) {
          auth.showToast("Success!", response.data.message);
          navigate("/pkb/success");
        }
      } catch (e) {
        auth?.showToast("Error!", e.response.data.message);
        navigate("/");
      } finally {
        setPkbLoading(false);
      }
    };

    if (code) {
      sendPKBConsent();
    } else if (error) {
      auth?.showToast("Error!", error);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash === "#nhs-card-id" && !loading && !isLoading) {
      const timer = setTimeout(() => {
        document
          .getElementById("nhs-card-id")
          ?.scrollIntoView({ behavior: "smooth", block: "start" });

        window.history.replaceState(
          null,
          "",
          window.location.pathname + window.location.search
        );
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [loading, isLoading]);

  useEffect(() => {
    if (
      location.search.includes("?redirect_to_pkb=true") &&
      getResult.data?.pkb_redirection_url &&
      (!isLoading || !loading || !pkbLoading)
    ) {
      window.location.href = redirectLink;
    }
    if (getResult?.data?.test_kits?.data[0]?.is_block_kit) {
      setErrors(blockedKitError);
    }
  }, [getResult]);

  const assessment = {
    requireAssessment:
      test?.test_kit_type &&
      (test?.test_kit_type?.startsWith("blood-") ||
        test?.test_kit_type?.startsWith("boots-blood-")),
    hasFilledAssessment: test?.assessment_id,
    canEditAssessment: test?.can_edit_assessment,
  };

  // Memoizes accordion items to prevent re-calculating on every render
  const memoizedReports = useMemo(
    () =>
      reports?.map((report) => {
        const accordionItems = report.health_areas?.map((area) => ({
          name: area.name,
          tag: area.tag,
          personalised_description: area.personalised_description,
          description: area.description,
          effect: area.effect,
          value: area.value,
          lead: area.lead,
          advice: area.advice,
          advisements: report.advice,
          snps: report.snps.filter((item) => area.snps.includes(item.snp)),
          further_research_required: report.further_research_required,
          missing: area.missing,
        }));
        return {
          ...report,
          accordionItems,
        };
      }),
    [reports],
  );

  if (
    (!test && !reports && (isLoading || loading)) ||
    pkbLoading ||
    (isTestKitDetails ? !testDetails : "")
  )
    return (
      <div className="text-center">
        <Spinner
          animation="border"
          variant="info"
          className="my-custom-spinner"
        />
      </div>
    );

  // Render instructions
  // const renderInstructions = () => {
  //   let nextStep = steps[currentStepIndex] || { title: () => null };

  //   // If next step is 'assessment, skip to another step
  //   if (nextStep.name === "assessment") {
  //     nextStep = steps[currentStepIndex + 2] || { title: () => null };
  //   }

  //   // If it is Menopause or PCOS test AND assessment wasn't filled
  //   // AND still can be filled - then show warning
  //   if (
  //     (test?.type === "blood-menopause" || test?.type === "blood-polycystic") && !assessment.hasFilledAssessment &&
  //     assessment.canEditAssessment
  //   )
  //     return (
  //       <div>
  //         <p className="text-justify">
  //           Our records show that we have not received your completed Health
  //           Assessment for <strong>{test?.type_name}</strong>, and without this,
  //           you will not receive your results.
  //         </p>

  //         <p className="text-justify">
  //           The information you submit will provide health and lifestyle context
  //           for the doctor who reviews your results. We will also ask you
  //           questions about your menstrual cycle because blood results can
  //           depend on the phase of a woman’s cycle.
  //         </p>
  //       </div>
  //     );

  //   if (!nextStep.instructions) return null;

  //   return nextStep.instructions({
  //     test_id: test?.id,
  //     bid: test?.bid,
  //     viewInstructionsUrl,
  //     filledAssessment: !!assessment.hasFilledAssessment,
  //     errorReason: test?.archive_reason,
  //     errorReasonMessage: test?.archive_reason_message,
  //     consultation_status: test?.consultation_status,
  //   });
  // };

  const anyStepFailed = steps.some((step) =>
    step.failed?.(
      test?.test_kit_status,
      test?.archive_reason,
      test?.is_activated,
      test?.consultation_status,
    ),
  );
  let reportReady = test?.test_kit_status === "report-ready";

  if (test?.type?.includes("dna")) {
    reportReady = test?.test_kit_status === "published";
  }

  let reportLink = `/my-reports/blood/${test?.report_id}`;
  if (test?.type?.includes("dna")) {
    reportLink = `/wellness-report/${test?.report_id}`;
  }
  const currentStep = steps.find((step) =>
    step.inProgress(
      test?.test_kit_status,
      test?.archive_reason,
      test?.consultation_status,
    ),
  );
  const currentStepIndex = steps.findIndex((step) => step === currentStep);
  let viewInstructionsUrl = "https://myhealthchecked.com/help/videos/blood";
  const isSexualHealthTest = test?.type?.indexOf("sex-health") !== -1;
  if (isSexualHealthTest) {
    viewInstructionsUrl =
      "https://myhealthchecked.com/help/videos/sexual-health";
  }

  let cardTitle =
    pkbConsented === "withdrawn-consent"
      ? "Reconnect results with the NHS App"
      : "See your results on the NHS App";

  if (errors === blockedKitError) {
    return <ErrorDisplay error={errors} consent={false} />;
  }

  return (
    <>
      {!isLoading && (
        <div className="row justify-content-center dashboard-page customer-dashboard">
          <div className="col-md-12">
            <div className="dashboard text-md-start">
              {isMobile ? (
                <Card>
                  <UserProfile
                    height={bodyDetails?.height}
                    weight={bodyDetails?.weight}
                    heightUnits={bodyDetails?.heightUnits}
                    weightUnits={bodyDetails?.weightUnits}
                    firstName={firstName}
                    gender={gender}
                    age={age}
                    isMobile={true}
                    assessmentId={test?.assessment_id}
                  />
                </Card>
              ) : (
                <UserProfile
                  height={bodyDetails?.height}
                  weight={bodyDetails?.weight}
                  heightUnits={bodyDetails?.heightUnits}
                  weightUnits={bodyDetails?.weightUnits}
                  firstName={firstName}
                  gender={gender}
                  age={age}
                  assessmentId={test?.assessment_id}
                />
              )}
              {!!reportReady && (
                <>
                  <div className="fs-px-22 test-kit-status mt-4">
                    <p className="fw-bold text-color-for-mhc fs-20">
                      Your latest test
                    </p>
                  </div>
                  {!isLoading && (
                    <div className="row result-published-card">
                      <ResultCard
                        report_link={reportLink}
                        test_name={test?.type_name}
                        test_type={test?.type}
                        resultDetails={false}
                        isMobile={isMobile}
                        testReportValue={testReportValue}
                        reportPublishedDate={reportPublishedDate}
                        dNAReportPublishedDate={dNAReportPublishedDate}
                        isVitaminB12Flag={isVitaminB12Flag}
                        vitabinB12reportPublishedDate={
                          vitabinB12reportPublishedDate
                        }
                        vitaminMarkerValue={vitaminMarkerValue}
                      />
                    </div>
                  )}
                  {
                    <div id="nhs-card-id" className="p-0 activate-box-wrapper my-4">
                      {pkbConsented === "inactive" && (
                        <ActionCard
                          image={nhsCardImage}
                          title={cardTitle}
                          bgColor="#D4CDCD8C"
                          titleColor={"text-black-color"}
                          button_text_1="No, help me register"
                          button_text_2="Yes, Sign in"
                          onClick_1={handleNo}
                          showBtn_2={true}
                          href_2={redirectLink}
                          button_append_class="custom-btn"
                        >
                          <p className="nhs-card-description">
                            We've partnered with Patients Know Best to seamlessly
                            integrate your health data.
                          </p>
                        </ActionCard>
                      )}
                      {pkbConsented === "withdrawn-consent" && (
                        <ActionCard
                          image={nhsCardImage}
                          title={cardTitle}
                          titleColor={"#D4CDCD8C"}
                          button_text_1="Reconnect now"
                          onClick_1={handleReactivateConsent}
                          showBtn_2={false}
                          button_append_class="my-button-class mt-2"
                        >
                          <p>
                            Select this option to reconnect your results with the NHS
                            App via{" "}
                            <strong className="bold-text">Patients Know Best</strong>.
                          </p>
                        </ActionCard>
                      )}
                    </div>
                  }
                </>
              )}



              {/* {auth?.isPkbLive && (
                <div className="p-0 activate-box-wrapper mt-4">
                  {pkbConsented === "inactive" && (
                    <ActionCard
                      image={PkbLogo}
                      title={cardTitle}
                      titleColor={"text-mhc-green"}
                      button_text_1="No, Register now"
                      button_text_2="Yes, Sign in"
                      onClick_1={handleNo}
                      showBtn_2={true}
                      href_2={redirectLink}
                      button_append_class="custom-btn"
                      isMobile={isMobile}
                    >
                      <p>
                        We've partnered with{" "}
                        <strong className="bold-text">
                          Patients Know Best
                        </strong>{" "}
                        to seamlessly integrate your health data.
                      </p>
                    </ActionCard>
                  )}
                  {pkbConsented === "withdrawn-consent" && (
                    <ActionCard
                      image={PkbLogo}
                      title={cardTitle}
                      titleColor={"text-mhc-green"}
                      button_text_1="Reconnect now"
                      onClick_1={handleReactivateConsent}
                      showBtn_2={false}
                      button_append_class="my-button-class mt-2"
                    >
                      <p>
                        Select this option to reconnect your results with the
                        NHS App via{" "}
                        <strong className="bold-text">
                          Patients Know Best
                        </strong>
                        .
                      </p>
                    </ActionCard>
                  )}
                </div>
              )} */}
              {/* {(test?.type_name && !reportReady &&  test.test_kit_status !== "error") && <h2 className="mb-4 mt-3">{test?.type_name}</h2>} */}

              {test?.status_name === "Activating" && (
                <div className="action-required-section">
                  <ActionRequiredCard test={test} />
                </div>
              )}

              {!test && !reportReady && (
                <div className="mb-0">
                  <div className="container-fluid activate-box-wrapper">
                    <div className="row">
                      {!["Activating", "published", "Activated"].includes(
                        test?.test_kit_status,
                      ) && (
                          <div className="col-md-12 first-test-card">
                            <LinkCard
                              to="/register-kit"
                              image={null}
                              title="Have a test kit already, click here"
                              button_text="Register test"
                              button_append_class="my-button-class"
                              cardColor="card-color"
                            >
                              <p>Register it to get started with your test</p>
                            </LinkCard>
                          </div>
                        )}
                    </div>
                  </div>
                </div>)}
              {test && testFlag === 1 ? (
                <>
                  <h2>{appointmentData?.type}</h2>
                  {test ? (
                    <AppointmentDetails
                      {...test}
                      testId={test?.id}
                      calendlyStatus={test?.calendly_status}
                      unconfirmedResultMessage={test?.unconfirmed_result_message}
                    />
                  ) : (
                    <></>
                  )}
                  {test?.archive_reason_message || test?.error_note ? (
                    (test?.error_note && test?.archive_reason_message) ||
                    test?.error_note ? (
                      test?.bid ? (
                        null
                      ) : (
                        <Alert
                          className="rounded dashboard-alert"
                          variant="danger"
                          dismissible={false}
                        >
                          <ReactMarkdown>{test?.error_note}</ReactMarkdown>
                        </Alert>
                      )
                    ) : test?.archive_reason_message && test?.bid ? (
                      <></>
                    ) : (
                      <Alert
                        className="rounded"
                        variant="danger"
                        dismissible={false}
                      >
                        <ReactMarkdown>
                          {test?.archive_reason_message}
                        </ReactMarkdown>
                      </Alert>
                    )
                  ) : null}
                  <div className="mb-4">
                    {/* {reportReady && test?.type !== "boots-blood-vitamin-b12" &&(
                      <>
                        <p>
                          Our doctor has reviewed your results. Your report has
                          been published and is ready to view.
                        </p>
                        <div className="d-flex test-kit-buttons">
                          <Button
                            className="align-content-center mx-2"
                            href={reportLink}
                            color="primary"
                            label="View report"
                          />
                          {assessment.hasFilledAssessment &&
                            !assessment.canEditAssessment && (
                              <Button
                                label="View health assessment"
                                className="view-health-assessment-btn mx-2"
                                href={`/assessment-details/${test?.id}`}
                                color="primary"
                                variant="outline-primary"
                              />
                            )}
                        </div>
                      </>
                    )} */}

                    {/* Show timeline only when report is NOT ready */}
                    {/* {!reportReady && (
                      <TimelineItem
                        test={test}
                        steps={steps}
                        assessment={assessment}
                        hasFilledAssessment={!!assessment.hasFilledAssessment}
                        canEditAssessment={!!assessment?.canEditAssessment}
                        currentStepIndex={currentStepIndex}
                        anyStepFailed={anyStepFailed}
                      />
                    )} */}

                    {!reportReady &&
                      test.test_kit_status !== "error" && test.test_kit_status !== "rejected-internal" && test?.status_name !== "Activating" && (
                        <>
                          {testKitTrackerTitle()}
                          <TestKitTracker
                            test={test}
                          />
                        </>
                      )}
                  </div>
                </>
              ) : test &&
                testFlag === 0 &&
                test.test_kit_status !== "published" ? (
                <>
                  {test.test_kit_status === "error" && (
                    <Alert
                      className="rounded"
                      variant="danger"
                      dismissible={false}
                    >
                      <ReactMarkdown>
                        {test?.archive_reason_message}
                      </ReactMarkdown>
                    </Alert>
                  )}
                  {/* {test && <WellnessTimeline test={test} />} */}
                   {test &&
                      (test.test_kit_status !== "error" && test.test_kit_status !== "rejected-internal") &&
                      test?.status_name !== "Activating" && (
                        <>
                          {testKitTrackerTitle()}
                          <TestKitTracker
                            test={test}
                            isNotDna={false}
                          />
                        </>
                    )}
                </>
              ) 
              // : !isLoading &&
              //   (test?.type?.includes("dna") ||
              //     test?.type?.includes("boots-dna-")) &&
              //   test?.test_kit_status == "published" &&
              //   memoizedReports?.length > 0 ? (
              //   memoizedReports?.map((report) => (
              //     <>
              //       <div className="container-fluid report-highlight-wrapper">
              //         <div className="mb-3">
              //           <ReportHighlightSection
              //             items={report.accordionItems}
              //             test_name={test?.type_name}
              //             report_id={test?.report_id}
              //             isLoading={isLoading}
              //           />
              //         </div>
              //       </div>
              //     </>
              //   ))
              // ) 
              : (
                !loading &&
                !isLoading && (
                  // <>
                  //   {/* <p>
                  //     Once you've completed your first test, you'll receive
                  //     personalised advice and support to improve your health.
                  //   </p> */}
                  //   {JSON.stringify(loading)}
                  //                       {JSON.stringify(isLoadingloading)}

                  //   <div className="mb-4">
                  //     <div className="container-fluid activate-box-wrapper">
                  //       <div className="row">
                  //         <div className="col-md-12 first-test-card">
                  //           <LinkCard
                  //             to="/register-kit"
                  //             image={null}
                  //             title="Have a test kit already, click here"
                  //             button_text="Register test"
                  //             button_append_class="my-button-class"
                  //             cardColor="card-color"
                  //           >
                  //             <p>Register it to get started with your test</p>
                  //           </LinkCard>
                  //         </div>
                  //         {isMobile ? (
                  //           ""
                  //         ) : (
                  //           <>
                  //             <div className="col-md-12 mb-4">
                  //               <div class="justify-content-between d-flex">
                  //                 <div>
                  //                   <span className="test-kit-title">
                  //                     Interested in further tests{" "}
                  //                   </span>
                  //                   <br />
                  //                   <span className="test-kit-description">
                  //                     Browse our at-home tests to discover what
                  //                     suits your goal
                  //                   </span>
                  //                 </div>
                  //                 <div>
                  //                   <Button
                  //                     href="https://myhealthchecked.com/our-tests"
                  //                     target="_blank"
                  //                     className="btn-green-color"
                  //                     label="View all"
                  //                   />
                  //                 </div>
                  //               </div>
                  //             </div>
                  //           </>
                  //         )}
                  //         <div className="col-md-12">
                  //           <div className="card test-kit-carousel-card mb-4">
                  //             {isMobile ? (
                  //               <>
                  //                 <div class="justify-content-between d-flex">
                  //                   <div className="mb-2">
                  //                     <h3 className="test-kit-title mb-1">
                  //                       Interested in further tests{" "}
                  //                     </h3>
                  //                     <p className="test-kit-description">
                  //                       Browse our at-home tests to discover
                  //                       what suits your goal
                  //                     </p>
                  //                   </div>
                  //                 </div>
                  //                 <TestKitCarousel />
                  //                 <div>
                  //                   <Button
                  //                     href="https://myhealthchecked.com/our-tests"
                  //                     target="_blank"
                  //                     className="btn-green-color w-100 mt-3"
                  //                     label="View all"
                  //                   />
                  //                 </div>
                  //               </>
                  //             ) : (
                  //               <TestKitCarousel />
                  //             )}
                  //           </div>
                  //           {/* <LinkCard
                  //             to="https://myhealthchecked.com/our-tests"
                  //             image={Test}
                  //             title="Buy tests"
                  //             button_text="Buy now"
                  //             button_append_class="my-button-class"
                  //           >
                  //             <p>
                  //               Get started today by buying a wellness test with
                  //               us!
                  //             </p>
                  //           </LinkCard> */}
                  //         </div>
                  //         {/* <div className="col-md-12">
                  //           <LinkCard
                  //             to="/activate"
                  //             image={Pink}
                  //             title="Activate test"
                  //             button_text="Activate"
                  //             button_append_class="my-button-class"
                  //           >
                  //             <p>
                  //               Already have a test and need to get it activated?
                  //             </p>
                  //           </LinkCard>
                  //         </div> */}
                  //         <div className="col-md-12">
                  //           <div class="justify-content-between d-flex">
                  //             <div>
                  //               <span className="test-kit-title">
                  //                 Explore our customer testimonials{" "}
                  //               </span>
                  //               <br />
                  //               <span className="test-kit-description">
                  //                 Discover how our tests have helped others
                  //               </span>
                  //             </div>
                  //             {isMobile ? (
                  //               ""
                  //             ) : (
                  //               <div>
                  //                 <Button
                  //                   href="https://myhealthchecked.com/articles/customer-stories"
                  //                   target="_blank"
                  //                   className="btn-green-color"
                  //                   label="View all"
                  //                 />
                  //               </div>
                  //             )}
                  //           </div>
                  //         </div>
                  //         <div className="col-md-12">
                  //           <DashboardArticleCarousel isMobile={isMobile} />
                  //         </div>
                  //         {isMobile ? (
                  //           <div>
                  //             <Button
                  //               href="https://myhealthchecked.com/articles/customer-stories"
                  //               target="_blank"
                  //               className="btn-green-color w-100"
                  //               label="View all"
                  //             />
                  //           </div>
                  //         ) : (
                  //           ""
                  //         )}
                  //       </div>
                  //     </div>
                  //   </div>
                  // </>
                  <></>
                )
              )}
              <>
                {/* <p>
                      Once you've completed your first test, you'll receive
                      personalised advice and support to improve your health.
                    </p> */}

                <div className="mb-4">
                  <div className="container-fluid activate-box-wrapper">
                    <div className="row">

                      {/* test kit carousel */}
                      {isMobile ? (
                        ""
                      ) : (
                        <>
                          <div className="col-md-12 mb-4">
                            <div class="justify-content-between d-flex">
                              <div>
                                <span className="test-kit-title">
                                  Interested in further tests{" "}
                                </span>
                                <br />
                                <span className="test-kit-description">
                                  Browse our at-home tests to discover what
                                  suits your goal
                                </span>
                              </div>
                              <div className="align-self-center">
                                <Button
                                  href="https://myhealthchecked.com/our-tests"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="btn-green-color mx-3 pt-2"
                                  label="View all"
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      <div className="col-md-12">
                        <div className="card test-kit-carousel-card">
                          {isMobile ? (
                            <>
                              <div class="justify-content-between d-flex">
                                <div className="mb-2">
                                  <h3 className="test-kit-title mb-1 fs-18">
                                    Interested in further tests{" "}
                                  </h3>
                                  <p className="test-kit-description fs-14">
                                    Browse our at-home tests to discover what
                                    suits your goal
                                  </p>
                                </div>
                              </div>
                              <TestKitCarousel />
                              <div>
                                <Button
                                  href="https://myhealthchecked.com/our-tests"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="btn-green-color w-100 mt-3 fs-16 pt-2"
                                  label="View all"
                                />
                              </div>
                            </>
                          ) : (
                            <>
                              <TestKitCarousel />
                            </>
                          )}
                        </div>
                      </div>

                      {/* learning something new */}
                      {!!reportReady && (
                        
                          (test?.type === "boots-blood-vitamin-b12" ||
                            test?.type === "blood-vitamin-b12") && (
                              <section className="text-color-for-mhc mb-4">
                                <h5 className="fs-30">
                                  <b className="text-color-for-mhc">
                                    Learning something new
                                  </b>
                                </h5>
                                <p
                                  className={`${isMobile ? "fs-16" : "fs-18"} text-color-for-mhc`}
                                  style={{ fontWeight: "500" }}
                                >
                                  Find expert guidance to help you understand and manage
                                  your health better.
                                </p>
                                {isMobile ? (
                                  <ArticleCard />
                                ) : (
                                  <ArticleCarouselB12
                                    article1={article1}
                                    article2={article2}
                                    article3={article3}
                                  />
                                )}
                              </section>
                            )
                      )}

                      {/* testimonial carousel section */}
                      <div className="col-md-12">
                        <div class="justify-content-between d-flex">
                          <div>
                            <span className="test-kit-title">
                              Explore our customer testimonials{" "}
                            </span>
                            <br />
                            <span className="test-kit-description">
                              Discover how our tests have helped others
                            </span>
                          </div>
                          {isMobile ? (
                            ""
                          ) : (
                            <div className="align-self-center">
                              <Button
                                href="https://myhealthchecked.com/articles/customer-stories"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn-green-color mx-3 pt-2"
                                label="View all"
                              />
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <DashboardArticleCarousel isMobile={isMobile} />
                      </div>
                      {isMobile ? (
                        <div>
                          <Button
                            href="https://myhealthchecked.com/articles/customer-stories"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn-green-color w-100 fs-16 pt-2"
                            label="View all"
                          />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </>
            </div>
            {!reportReady && (
              <>
                <div id="nhs-card-id" className="p-0 activate-box-wrapper my-4">
                  {pkbConsented === "inactive" && (
                    <ActionCard
                      image={nhsCardImage}
                      title={cardTitle}
                      bgColor="#D4CDCD8C"
                      titleColor={"text-black-color"}
                      button_text_1="No, help me register"
                      button_text_2="Yes, Sign in"
                      onClick_1={handleNo}
                      showBtn_2={true}
                      href_2={redirectLink}
                      button_append_class="custom-btn"
                    >
                      <p className="nhs-card-description">
                        We've partnered with Patients Know Best to seamlessly
                        integrate your health data.
                      </p>
                    </ActionCard>
                  )}
                  {pkbConsented === "withdrawn-consent" && (
                    <ActionCard
                      image={nhsCardImage}
                      title={cardTitle}
                      titleColor={"#D4CDCD8C"}
                      button_text_1="Reconnect now"
                      onClick_1={handleReactivateConsent}
                      showBtn_2={false}
                      button_append_class="my-button-class mt-2"
                    >
                      <p>
                        Select this option to reconnect your results with the NHS
                        App via{" "}
                        <strong className="bold-text">Patients Know Best</strong>.
                      </p>
                    </ActionCard>
                  )}
                </div>
              </>
            )
            }
            {/* {test?.type?.includes("blood-") && !test?.bid && (
              <AssessmentMessage
                assessment={assessment}
                status={test?.test_kit_status}
                test_id={test?.id}
              />
            )} */}
          </div>
        </div>
      )}
    </>
  );
};

export default Dashboard;
